module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-regular.754c63cd1426bff4a89d.svg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.svg
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-regular.svg
// module chunks = styles